import React from 'react';
import { useAdminTheme } from '../../contexts/AdminThemeContext';
import CreatePaymentFormEnhanced from '../payment/CreatePaymentFormEnhanced';

const CreatePayment = () => {
  const { isDarkMode } = useAdminTheme();

  return (
    <div className={`max-w-8xl mx-auto px-4 sm:px-5 lg:px-6 py-6 transition-colors duration-300 ${
      isDarkMode ? 'bg-skyone-page-dark' : 'bg-gray-50'
    }`}>
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className={`text-3xl font-bold transition-colors duration-300 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>Create Payment Request</h1>
          <p className={`mt-2 transition-colors duration-300 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-600'
          }`}>
            Send a secure payment link to your client via email
          </p>
        </div>
        
        <CreatePaymentFormEnhanced />
      </div>
    </div>
  );
};

export default CreatePayment;
